import PhoneIcon from '@mui/icons-material/Phone'
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded'
import { Box, Container, InputAdornment, Typography } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import * as Yup from 'yup'

import * as routes from '../../config/constants'
import Button from '../../shared/Button'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import {
  getError,
  getLoading,
  getMessage,
  getRegisterUserId,
  phoneNumberSet,
  receiveAppToken,
  register,
  setError,
  setMessage,
} from '../../store/auth'

interface FormValues {
  phoneNumber: string
  password: string
}
// Define interface and  validationSchema form
const initialValues: FormValues = { phoneNumber: '', password: '' }

const validationSchema = Yup.object().shape({
  phoneNumber: Yup.string().max(11).required().label('phone number'),
  password: Yup.string().max(10).required().label('password'),
})

const RegisterScreen: React.FC = () => {
  const { t } = useTranslation()
  const [phone, setPhone] = useState('')
  const dispatch = useDispatch<Dispatch<any>>()
  const userId = useSelector(getRegisterUserId)
  const message = useSelector(getMessage)
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const error = useSelector(getError)
  const handleSubmit = (values: any) => {
    dispatch(register(values))
    setPhone(values)
    dispatch(phoneNumberSet(values.phoneNumber))
  }

  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
    // navigate(`/${routes.CARS}`)
  }, [message])
  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  useEffect(() => {
    if (userId === undefined) {
      return
    }
    navigate(`/${routes.CONFIRM_REGISTER}`, { state: { phoneNumber: phone } })
  }, [userId])
  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener('popstate', function (event) {
      window.history.pushState(null, document.title, window.location.href)
    })
  }, [])
  return (
    <Container fixed maxWidth='xs'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Box display='flex' justifyContent='center'>
          <img alt='Logo' src='images/Logo.png' />
        </Box>
        <Box sx={{ mb: 2, ml: 1, direction: 'rtl' }}>
          <Typography sx={{ color: 'grey.700' }} variant='h5'>
            {t('screens.auth.register.title')}
          </Typography>
        </Box>
        <Box sx={{ direction: 'ltr' }}>
          <Form
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            <FormField
              name='phoneNumber'
              placeholder={t('screens.auth.register.phone_number_placeholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <PhoneIcon />
                </InputAdornment>
              }
            />
            <FormField
              name='password'
              placeholder={t('screens.auth.register.password_placeholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <VpnKeyRoundedIcon />
                </InputAdornment>
              }
            />
            <SubmitButton fullWidth title={t('screens.auth.register.submit_button_text')} />
          </Form>
        </Box>
        <Box sx={{ mt: 2, display: 'flex' }}>
          <Typography
            sx={{ color: 'grey.700', fontSize: 18, alignItems: 'center', display: 'flex' }}
            variant='h5'
          >
            {t('screens.auth.register.title_before_register')}
          </Typography>
          <Button onClick={() => navigate(`/${routes.LOGIN}`, { replace: true })} variant='text'>
            {t('screens.auth.register.login_button_text')}
          </Button>
        </Box>
      </Box>
    </Container>
  )
}

export default RegisterScreen
